var render = function () {
  var _vm$areaList$filter$;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step1 step"
  }, [_vm.consumerAccount ? _c('div', {
    staticClass: "oauth-notice"
  }, [_c('div', {
    staticClass: "oauth-user"
  }, [_c('img', {
    staticClass: "oauth-avatar",
    attrs: {
      "src": _vm.consumerAvatarUrl,
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oauth-user-info"
  }, [_c('p', {
    staticClass: "oauth-notice-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.oauthLoginTitle', {
    account: _vm.consumerAccount
  })) + "\n        ")]), _vm._v(" "), !_vm.hasExistingSeller ? _c('p', {
    staticClass: "oauth-notice-desc"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.oauthLoginDesc')) + "\n        ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _vm.hasExistingSeller ? _c('div', {
    staticClass: "existing-account"
  }, [_c('p', {
    staticClass: "existing-account-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('createSellerAccount.step1.existingAccountTitle', {
    account: _vm.existingSellerName
  })) + "\n    ")]), _vm._v(" "), _vm.showChooseStore ? [_c('p', {
    staticClass: "existing-account-desc"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('sc.components.chooseStore')) + "\n      ")]), _vm._v(" "), _c('Select', {
    staticClass: "select",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.store,
      callback: function ($$v) {
        _vm.store = $$v;
      },
      expression: "store"
    }
  }, _vm._l(_vm.stores, function (item) {
    return _c('Option', {
      key: item.storeId,
      attrs: {
        "value": JSON.stringify(item)
      }
    }, [_vm._v("\n          " + _vm._s(item.storeName) + "\n        ")]);
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "existing-account-actions"
  }, [_c('button', {
    staticClass: "myBtn confirmBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.storeLogin
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.components.login')) + "\n        ")])])] : [_c('p', {
    staticClass: "existing-account-desc"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('createSellerAccount.step1.existingAccountQuestion')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "existing-account-actions"
  }, [_c('button', {
    staticClass: "myBtn cancelBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleExistingAccountCancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.existingAccountCancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "myBtn confirmBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleExistingAccountConfirm
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.existingAccountConfirm')) + "\n        ")])])]], 2) : [_vm.isShowVcode ? _c('Vcode', {
    attrs: {
      "successText": _vm.$t('createSellerAccount.step1.successText'),
      "failText": _vm.$t('createSellerAccount.step1.failText'),
      "sliderText": _vm.$t('createSellerAccount.step1.sliderText'),
      "show": _vm.isShow
    },
    on: {
      "success": _vm.onSuccess,
      "close": _vm.onClose
    }
  }) : _vm._e(), _vm._v(" "), _c('Form', {
    ref: "formValidate",
    staticStyle: {
      "margin-right": "70px"
    },
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 140
    }
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n        Tips:" + _vm._s(_vm.$t('createSellerAccount.step1.tips')) + "\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.account'),
      "prop": "account"
    }
  }, [_c('Input', {
    staticClass: "input-width",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formValidate.account,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "account", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.account"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.pwd'),
      "prop": "pwd"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": ""
    },
    model: {
      value: _vm.formValidate.pwd,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "pwd", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.pwd"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.confirmPwd'),
      "prop": "confirmPwd"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": ""
    },
    model: {
      value: _vm.formValidate.confirmPwd,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "confirmPwd", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.confirmPwd"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.phone'),
      "prop": "area"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": _vm.$t('sc.storeSetting.selectCountry')
    },
    model: {
      value: _vm.formValidate.area,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "area", $$v);
      },
      expression: "formValidate.area"
    }
  }, [_vm.formValidate.area ? _c('Avatar', {
    attrs: {
      "slot": "prefix",
      "src": ((_vm$areaList$filter$ = _vm.areaList.filter(function (areaItem) {
        return areaItem.regionId === _vm.formValidate.area;
      })[0]) === null || _vm$areaList$filter$ === void 0 ? void 0 : _vm$areaList$filter$.flag) || '',
      "size": "small",
      "shape": "square"
    },
    slot: "prefix"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.areaList, function (item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_c('Avatar', {
      attrs: {
        "src": item.flag,
        "shape": "square"
      }
    }), _vm._v("\n              " + _vm._s(item.name + '   +' + item.callingCode) + "\n            ")], 1);
  })], 2)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "phone",
      "label-width": 0
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 5
    }
  }, [_c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": _vm.$t('createSellerAccount.step1.fillInPhoneNumber'),
      "type": "tel",
      "disabled": !_vm.formValidate.area || _vm.phoneLocked
    },
    on: {
      "on-keydown": _vm.keydownPhone
    },
    model: {
      value: _vm.formValidate.phone,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "phone", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.phone"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('SendCode', {
    ref: "sendCode",
    nativeOn: {
      "click": function ($event) {
        return _vm.sendCode.apply(null, arguments);
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.code'),
      "prop": "code"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    model: {
      value: _vm.formValidate.code,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "code", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.code"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.sellerType'),
      "prop": "merchantType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: _vm.formValidate.merchantType,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "merchantType", $$v);
      },
      expression: "formValidate.merchantType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.businessIfYou')) + "\n        ")]), _vm._v(" "), _vm.formValidate.area !== 2 ? _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.individualIfYou')) + "\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.email'),
      "prop": "email"
    }
  }, [_c('div', {
    staticClass: "line-box"
  }, [_c('Input', {
    attrs: {
      "placeholder": "",
      "type": "email"
    },
    model: {
      value: _vm.formValidate.email,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.email"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.step1.useToReceiveAccountRelated')) + "\n        ")])], 1)]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('createSellerAccount.step1.referralCode')
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    model: {
      value: _vm.formValidate.referenceNo,
      callback: function ($$v) {
        _vm.$set(_vm.formValidate, "referenceNo", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formValidate.referenceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('button', {
    staticClass: "sendCodeBtn myBtn",
    attrs: {
      "type": "button",
      "disabled": _vm.clicked
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formValidate');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('createSellerAccount.next')) + "\n      ")])])], _vm._v(" "), _vm.consumerAccount && !_vm.hasExistingSeller ? _c('div', {
    staticClass: "oauth-reminder"
  }, [_c('p', {
    staticClass: "oauth-reminder-title",
    domProps: {
      "innerHTML": _vm._s(_vm.oauthReminderHtml)
    }
  })]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }